import db from "../../database";
import { getOAuthHeaders } from "../../constants/oAuthValidation";
import { v4 as uuidv4 } from "uuid";
import { syncDocTypes, syncRFIDData, syncRFIDScanConfig, syncSalesRepData } from "../../services/generic";
import {
  syncAllProductCategories,
  syncProductCategories,
  syncPosSaleTypes,
  syncProductsUom,
  syncProducts,
  syncPricingRules,
  syncOfflineDta,
  syncPosConfigData,
  syncLoyalityData,
  syncGiftCardData,
  getApprovals,
  getExpenseCategory,
  syncRestaurantTables,
} from "../../services";
import moment from "moment";

let cleanToken;
let syncId;
let tillId;
const authHeaders = getOAuthHeaders();
if (authHeaders) {
  cleanToken = authHeaders.access_token;
}

export const processSync = async (data, setGlobalStore, type) => {
  const tillData = data ? data : JSON.parse(localStorage.getItem("tillData"));
  let syncType = "Incremental Sync";
  const lastUpdatedTime = localStorage.getItem("lastUpdatedTime");
  if (lastUpdatedTime === undefined || lastUpdatedTime === null) {
    syncType = "Full Sync";
    await deletePreviousData();
  }
  try {
    let startTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
    tillId = JSON.parse(localStorage.getItem("tillValue"))?.cwr_till_id;
    syncId = uuidv4().replace(/-/g, "").toUpperCase();
    await db.dataSyncSummary.add({ syncId: syncId, syncType: syncType, syncStartTime: startTime });
    setGlobalStore({ percent: "15%" });
    setGlobalStore({ productCategoryPercentage: "38" });
    await syncAllProductCategories(tillId, syncId);
    setGlobalStore({ percent: "30%" });
    setGlobalStore({ productCategoryPercentage: "55" });
    setGlobalStore({ productPercentage: "15" });
    await syncProductCategories(tillData, tillId, syncId);
    setGlobalStore({ percent: "45%" });
    setGlobalStore({ productCategoryPercentage: "70" });
    setGlobalStore({ productPercentage: "30" });
    await syncPosSaleTypes(syncId, tillId, tillData);
    setGlobalStore({ percent: "53%" });
    setGlobalStore({ productCategoryPercentage: "100" });
    setGlobalStore({ productPercentage: "47" });
    await syncProductsUom(syncId, tillId);
    setGlobalStore({ percent: "64%" });
    setGlobalStore({ productPercentage: "56" });
    setGlobalStore({ percent: "75%" });
    setGlobalStore({ productPercentage: "69" });
    await syncProducts(tillData, syncId, tillId);
    setGlobalStore({ percent: "84%" });
    setGlobalStore({ promotionPercentage: "25" });
    setGlobalStore({ productPercentage: "77" });
    await syncPricingRules(tillData, syncId, tillId);
    await syncOfflineDta(tillData, syncId, tillId);
    setGlobalStore({ percent: "90%" });
    setGlobalStore({ promotionPercentage: "55" });
    setGlobalStore({ productPercentage: "85" });
    await syncPosConfigData(syncId, tillId);
    setGlobalStore({ percent: "95%" });
    setGlobalStore({ productPercentage: "100" });
    setGlobalStore({ promotionPercentage: "79" });
    await syncLoyalityData(syncId, tillId);
    await syncGiftCardData(syncId, tillId);
    await getApprovals();
    await getExpenseCategory(syncId);
    await syncDocTypes();
    syncRestaurantTables();
    await syncRFIDData(syncId);
    await syncRFIDScanConfig(tillData);
    await syncSalesRepData(tillData);
    await filterBrandAndCategoty();
    setGlobalStore({ percent: "99%" });
    setGlobalStore({ promotionPercentage: "100" });
    await db.dataSyncSummary
      .where("syncId")
      .equals(syncId)
      .modify((event) => {
        event.syncEndTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      });
    localStorage.setItem("lastUpdatedTime", startTime);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deletePreviousData = () => {
  return new Promise(async (deletionSuccess, deletionFailure) => {
    try {
      await db.productCategories.clear();
      await db.AllProductCategories.clear();
      await db.products.clear();
      await db.pricingRules.clear();
      await db.posSaletypes.clear();
      await db.productUom.clear();
      await db.rfidData.clear();
      await db.loyalityData.clear();
      await db.POSWorkFlowRules.clear();
      await db.approvers.clear();
      await db.productBrands.clear();
      await db.giftCardData.clear();
      await db.docTypesData.clear();
      deletionSuccess();
    } catch (error) {
      deletionFailure(error);
    }
  });
};

const filterBrandAndCategoty = async () => {
  let products = await db.products.filter((product) => product.isactive === true).toArray();
  let brandDetails = await db.productBrands.toArray();
  let categoryDetails = await db.productCategories.toArray();
  await db.productBrands.clear();
  await db.productCategories.clear();
  const getUniqueBrandsAndCategories = (products) => {
    const brands = new Set();
    const categories = new Set();

    products.forEach((product) => {
      brands.add(product.brandId);
      categories.add(product.mProductCategoryId);
    });

    return {
      brands: Array.from(brands),
      categories: Array.from(categories),
    };
  };
  const { brands, categories } = getUniqueBrandsAndCategories(products);

  const filterBrandsAndCategories = (brands, categories, brandDetails, categoryDetails) => {
    const filteredBrands = brands.reduce((acc, brandId) => {
      const brandDetail = brandDetails.find((brand) => brand.brandId === brandId);
      if (brandDetail) {
        acc.push(brandDetail);
      }
      return acc;
    }, []);

    const filteredCategories = categories.reduce((acc, categoryId) => {
      const categoryDetail = categoryDetails.find((category) => category.mProductCategoryId === categoryId);
      if (categoryDetail) {
        acc.push(categoryDetail);
      }
      return acc;
    }, []);

    return {
      filteredBrands,
      filteredCategories,
    };
  };

  const { filteredBrands, filteredCategories } = filterBrandsAndCategories(brands, categories, brandDetails, categoryDetails);
  await db.productBrands.bulkPut(filteredBrands);
  await db.productCategories.bulkPut(filteredCategories);
};
